import { requestNavigationTransition } from "./navigationTransition";

// Future APK swipe bridge may dispatch this event; it never sends a command.
export const MANUAL_REFRESH_EVENT = "pharmhub:manual-refresh";
export const REFRESH_AVAILABILITY_EVENT = "pharmhub:refresh-availability";
const blockers = new Set<symbol>();
export function manualRefreshBlocked(): boolean { return blockers.size > 0; }
export function holdManualRefresh(): () => void {
  const token = Symbol();
  blockers.add(token);
  if (typeof window !== "undefined") window.dispatchEvent(new Event(REFRESH_AVAILABILITY_EVENT));
  return () => {
    blockers.delete(token);
    if (typeof window !== "undefined") window.dispatchEvent(new Event(REFRESH_AVAILABILITY_EVENT));
  };
}
export function mountManualRefresh(target: EventTarget, refresh: () => void): () => void {
  const guarded = () => { if (!manualRefreshBlocked()) refresh(); };
  const listener = () => { if (!manualRefreshBlocked()) requestNavigationTransition(guarded, undefined, target); };
  target.addEventListener(MANUAL_REFRESH_EVENT, listener);
  return () => target.removeEventListener(MANUAL_REFRESH_EVENT, listener);
}
